  /* escHtml lives up top: editable theme-setting text flows into innerHTML all over this file */
  const escHtml = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ===== FEATURED DISHES — real Aktivate photography ===== */
  const W = 'width=900';
  const dishes = [{"name": "Pesto Chicken Power Bowl", "cat": "Chicken · Power Bowl", "badge": "Best Seller", "desc": "A low-carb, flavor-packed bowl featuring tender chicken breast tossed in our house-made broccoli rabe pesto, crafted with extra virgin olive oil, pine", "price": "$14.99", "protein": 42, "cal": 366, "carb": 9, "accent": "#3E7A4E", "tint": "rgba(62,122,78,0.14)", "img": "https://cdn.shopify.com/s/files/1/0911/3891/6655/files/put-it-into-a-white-bowl-make-the-cubes-smaller.png?v=1774362488&width=900"}, {"name": "Habibi Steak", "cat": "Steak · Halal", "badge": "High Protein", "desc": "Halal-grade flank steak (6 oz), marinated with garlic and herbs, grilled tender and served with oven-roasted red potatoes and a side of seasoned veget", "price": "$16.99", "protein": 50, "cal": 580, "carb": 41, "accent": "#3E7A4E", "tint": "rgba(62,122,78,0.14)", "img": "https://cdn.shopify.com/s/files/1/0911/3891/6655/files/11225918-1758-466F-82C4-B832C488DE9E.png?v=1775654171&width=900"}, {"name": "Pancho Villa Shrimp Fajita", "cat": "From the Water", "badge": "Chef's Pick", "desc": "Juicy chili-lime marinated shrimp sautéed with garlic, cumin, chili powder, smoked paprika, and onion powder, finished with fresh lime juice and extra", "price": "$17.99", "protein": 26, "cal": 430, "carb": 46, "accent": "#3E7A4E", "tint": "rgba(62,122,78,0.14)", "img": "https://cdn.shopify.com/s/files/1/0911/3891/6655/files/show-the-plate-more.png?v=1770133309&width=900"}, {"name": "Turkey Sausage & Egg Quesadillas", "cat": "Breakfast", "badge": "High Protein", "desc": "A high-protein breakfast quesadilla made with lean ground turkey, egg whites, cottage cheese, and low-fat cheese, folded into a whole wheat tortillas ", "price": "$12.99", "protein": 62, "cal": 680, "carb": 45, "accent": "#3E7A4E", "tint": "rgba(62,122,78,0.14)", "img": "https://cdn.shopify.com/s/files/1/0911/3891/6655/files/EC1F415B-0FB4-43E2-8693-1BF43E5514A9_d6fd067b-25d1-4134-9b54-344c900eb9c8.png?v=1770743863&width=900"}, {"name": "Biscoff Protein Cheesecake", "cat": "Dessert · Guilt-Free", "badge": "Sweet & Lean", "desc": "Greek yogurt, collagen, whey protein, graham crackers, avocado, Biscoff.", "price": "$10.00", "protein": 17, "cal": 295, "carb": 21, "accent": "#3E7A4E", "tint": "rgba(62,122,78,0.14)", "img": "https://cdn.shopify.com/s/files/1/0911/3891/6655/files/IMG_73852.jpg?v=1763652412&width=900"}];

  if (document.getElementById('dishFrame')) { // hero: homepage only
  // Theme-editor hero picks win over the built-in defaults; macros gap-filled from AKTIVATE_MACROS
  if (window.AKTIVATE_HERO && window.AKTIVATE_HERO.length) {
    const M = window.AKTIVATE_MACROS || {};
    window.AKTIVATE_HERO.forEach(h => {
      const m = M[h.handle];
      if (m) {
        if (h.protein == null && m.p != null) h.protein = m.p;
        if (h.cal == null && m.cal != null) h.cal = m.cal;
        if (h.carb == null && m.c != null) h.carb = m.c;
        if ((!h.badge || h.badge === 'Chef-Made') && m.badge) h.badge = m.badge;
      }
    });
    dishes.length = 0;
    window.AKTIVATE_HERO.forEach(h => dishes.push(h));
  }
  const ROTATE_MS = 4400;
  let cur = 0, timer = null;

  const root     = document.documentElement;
  const frame    = document.getElementById('dishFrame');
  const thumbsEl = document.getElementById('thumbs');
  const progBar  = document.getElementById('progressBar');

  frame.innerHTML = ''; // clear the static fallback image before building the carousel
  dishes.forEach((d, i) => {
    const img = document.createElement('img');
    img.className = 'dish-img'; img.src = d.img; img.alt = d.name.replace('<br>', ' ');
    if (i === 0) img.classList.add('active');
    frame.appendChild(img);

    const t = document.createElement('button');
    t.className = 'thumb' + (i === 0 ? ' active' : '');
    t.innerHTML = `<img src="${d.img}" alt="">`;
    t.addEventListener('click', () => goTo(i, true));
    thumbsEl.appendChild(t);
  });
  document.getElementById('totIdx').textContent = String(dishes.length).padStart(2, '0');

  const imgs   = frame.querySelectorAll('.dish-img');
  const thumbs = thumbsEl.querySelectorAll('.thumb');

  function countTo(el, target, dur = 700) {
    const start = parseInt(el.dataset.val || el.textContent) || 0;
    el.dataset.val = target;
    const t0 = performance.now();
    (function step(now) {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(start + (target - start) * eased);
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  function render(i) {
    const d = dishes[i];
    document.getElementById('dishName').innerHTML = d.name.replace(/<br>/g, ' ');
    document.getElementById('dishCat').textContent = d.cat;
    document.getElementById('dishDesc').textContent = d.desc;
    document.getElementById('dishPrice').textContent = d.price;
    document.getElementById('badgeText').textContent = d.badge;
    [['mProteinV', d.protein], ['mCalV', d.cal], ['mCarbV', d.carb]].forEach(([id, v]) => {
      const el = document.getElementById(id);
      if (v == null) { el.textContent = '\u2013'; delete el.dataset.val; }
      else countTo(el, v);
    });
    /* brand green stays consistent across the site — no per-dish accent shift */
    imgs.forEach((im, k) => im.classList.toggle('active', k === i));
    thumbs.forEach((t, k) => t.classList.toggle('active', k === i));
    document.getElementById('curIdx').textContent = String(i + 1).padStart(2, '0');
    ['dishName','dishCat','dishDesc'].forEach(id => {
      const el = document.getElementById(id);
      el.style.animation = 'none'; void el.offsetWidth;
      el.style.animation = 'rise 0.7s cubic-bezier(0.16,1,0.3,1) forwards';
    });
  }

  function restartProgress() {
    progBar.style.transition = 'none'; progBar.style.width = '0%';
    void progBar.offsetWidth;
    progBar.style.transition = `width ${ROTATE_MS}ms linear`;
    progBar.style.width = '100%';
  }
  function goTo(i, manual = false) { cur = (i + dishes.length) % dishes.length; render(cur); restartProgress(); if (manual) resetTimer(); }
  function next() { goTo(cur + 1); }
  function startTimer() { timer = setInterval(next, ROTATE_MS); restartProgress(); }
  function resetTimer() { clearInterval(timer); startTimer(); }

  const stageEl = document.querySelector('.stage');
  stageEl.addEventListener('mouseenter', () => { clearInterval(timer); timer = null; progBar.style.transition = 'none'; });
  stageEl.addEventListener('mouseleave', () => startTimer());

  window.addEventListener('load', () => setTimeout(startTimer, 900));
  setTimeout(() => { if (!timer) startTimer(); }, 1500);
  } // end hero guard

  /* nav scroll (global chrome) */
  const navEl = document.getElementById('nav');
  if (navEl) window.addEventListener('scroll', () => { navEl.classList.toggle('scrolled', window.scrollY > 40); }, { passive: true });

  /* ===================================================================
     FULL MENU — real Aktivate photography
     =================================================================== */
  const CDN = 'https://www.aktivatekitchen.com/cdn/shop/files/';
  const ww = '&width=600';


  /* filter (scoped to the menu's own pills — the prep builder has its own set) */
  const pillsEl = document.getElementById('pills');
  if (pillsEl) pillsEl.addEventListener('click', e => {
    const btn = e.target.closest('.pill'); if (!btn) return;
    pillsEl.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const f = btn.dataset.f;
    document.querySelectorAll('#grid .card').forEach(card => {
      card.classList.toggle('hide', !(f === 'all' || card.dataset.c === f));
    });
  });

  /* meal-prep builder: size chips on a card swap its price + the variant the "+" adds */
  document.addEventListener('click', e => {
    const chip = e.target.closest('.bulk-size'); if (!chip || chip.disabled) return;
    const card = chip.closest('.bulk-card'); if (!card) return;
    card.querySelectorAll('.bulk-size').forEach(c => c.classList.toggle('on', c === chip));
    const amt = card.querySelector('.bp-amt'), unitEl = card.querySelector('.bp-unit'), add = card.querySelector('.bulk-add');
    if (amt) amt.textContent = chip.dataset.price || amt.textContent;
    if (unitEl) unitEl.textContent = ' / ' + (chip.dataset.size || '');
    if (add) { add.dataset.variantId = chip.dataset.vid; add.dataset.size = chip.dataset.size || ''; add.disabled = false; }
  });

  /* meal-prep builder: category pills filter the bulk grid (same pattern as the menu) */
  const prepPillsEl = document.getElementById('prepPills');
  if (prepPillsEl) prepPillsEl.addEventListener('click', e => {
    const btn = e.target.closest('.pill'); if (!btn) return;
    prepPillsEl.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const f = btn.dataset.pf;
    document.querySelectorAll('#bulkGrid .bulk-card').forEach(cd => {
      cd.classList.toggle('hide', !(f === 'all' || cd.dataset.pc === f));
    });
  });

  /* Bulk items are Liquid-rendered from the Bulk collection (see aktivate-bottom.liquid) */

  /* ===================================================================
     BUNDLES — premium product cards (data-driven, easy to extend)
     =================================================================== */
  const bImg = f => `${CDN}${f}&width=600`;
  /* Shared 2x2 collage for every bundle — picked because these photos are (near-)square,
     so they fill the square cells edge-to-edge with no crop. Order: chicken, steak, fish, breakfast.
     (Miso Salmon is 4:5, the one non-square one — it takes a gentle center crop via object-fit:cover.) */
  const bundleCollage = [
    bImg('white-background-and-white-plate.png?v=1778596517'),       // Broccoli Rabe Pesto Chicken Wrap (square)
    bImg('no-just-put-it-all-in-one-plate.png?v=1774363825'),        // Habibi Chimichurri Flank Steak (square)
    bImg('ChatGPTImageMar17_2026at12_01_21AM.png?v=1775654263'),     // Miso Salmon (4:5, gentle crop)
    bImg('i-want-four-egg-bites-the-sweet-potatoes.png?v=1781707604'), // Turkey Bacon Egg Bites (square)
  ];
  const bundlesData = [
    { name:'5 Meal Pack',  meals:5,  price:'$74.99',  benefit:'Perfect for trying us out or a lighter week of chef-made meals.', items:['2 Chicken entrees','1 Steak entree','1 Fish entree','1 Breakfast'], quota:{ 'chicken-turkey-entrees':2, 'steak':1, 'from-the-water':1, 'breakfast':1 } },
    { name:'10 Meal Pack', meals:10, price:'$149.99', benefit:'Lunch and dinner handled all week long.', items:['4 Chicken entrees','2 Steak entrees','2 Fish entrees','2 Breakfasts'], quota:{ 'chicken-turkey-entrees':4, 'steak':2, 'from-the-water':2, 'breakfast':2 } },
    { name:'15 Meal Pack', meals:15, price:'$224.99', tag:'Most Popular', pop:true, perkMain:'Free Delivery', perkExtra:'+ Free Dessert', benefit:'The best price per meal. A full week of eating, completely sorted.', items:['6 Chicken entrees','3 Steak entrees','3 Fish entrees','3 Breakfasts'], quota:{ 'chicken-turkey-entrees':6, 'steak':3, 'from-the-water':3, 'breakfast':3 } },
    { name:'Weight Loss',  meals:20, price:'$289.99', benefit:'High-protein, calorie-conscious meals built around your goal.', items:['8 Chicken entrees','4 Steak entrees','4 Fish entrees','4 Breakfasts'], quota:{ 'chicken-turkey-entrees':8, 'steak':4, 'from-the-water':4, 'breakfast':4 } },
  ];
  // Bundle-card COPY from the theme editor (Aktivate Top → "Bundle card" blocks). Picker quotas
  // are derived from the meal count with the same 2:1:1:1 split the hardcoded cards used
  // (per 5 meals: 2 chicken / 1 steak / 1 fish / 1 breakfast; any remainder goes to chicken).
  const BCOPY = (window.AKTIVATE_BUNDLES || []).filter(b => b && b.meals > 0 && b.name);
  if (BCOPY.length) {
    const priceByMeals = {}; bundlesData.forEach(b => { priceByMeals[b.meals] = b.price; });
    const quotaFor = m => { const k = Math.floor(m / 5), rem = m - 5 * k;
      return { 'chicken-turkey-entrees': 2 * k + rem, 'steak': k, 'from-the-water': k, 'breakfast': k }; };
    bundlesData.length = 0;
    BCOPY.forEach(b => bundlesData.push({
      name: b.name, meals: b.meals, price: priceByMeals[b.meals] || '',
      tag: b.tag || undefined, pop: !!b.pop, benefit: b.benefit || '',
      perkMain: b.perkMain || '', perkExtra: b.perkExtra || '',
      items: String(b.items || '').split(/\r?\n/).map(s => s.trim()).filter(Boolean),
      quota: quotaFor(b.meals)
    }));
  }
  const PACKS = window.AKTIVATE_PACKS || null; // live pack-variant data when Build-Your-Box is Active
  if (PACKS) bundlesData.forEach(b => { const p = PACKS[String(b.meals)]; if (p && p.price) b.price = p.price; });
  const bgEl = document.getElementById('bundlesGrid');
  if (bgEl) bgEl.innerHTML = bundlesData.map(b => `
    <article class="bundle reveal${b.pop ? ' pop' : ''}">
      <div class="b-visual">
        ${bundleCollage.map(src => `<img src="${src}" alt="" loading="lazy" onerror="this.style.display='none';this.parentElement.classList.add('no-img')">`).join('')}
        <span class="b-count"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 3v7a2 2 0 0 0 4 0V3M6 12v9M18 3c-1.6 0-3 1.8-3 4s1.4 4 3 4v10"/></svg>${b.meals} Meals / week</span>
        ${b.tag ? `<span class="b-tag">${escHtml(b.tag)}</span>` : ''}
      </div>
      <div class="b-body">
        <div class="b-name">${escHtml(b.name)}</div>
        <div class="b-price">${escHtml(b.price)}<span> / wk</span></div>
        ${b.perkMain || b.perkExtra ? `<div class="b-perks">
          ${b.perkMain ? `<div class="b-perk-main"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>${escHtml(b.perkMain)}</div>` : ''}
          ${b.perkExtra ? `<div class="b-perk-extra"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>${escHtml(b.perkExtra)}</div>` : ''}
        </div>` : ''}
        <p class="b-benefit">${escHtml(b.benefit)}</p>
        <ul class="b-items">${b.items.map(it => `<li>${escHtml(it)}</li>`).join('')}</ul>
        <button class="b-btn" data-pack="${b.meals}" data-pack-price="${escHtml(b.price)}" data-pack-name="${escHtml(b.name)}" data-pack-quota='${JSON.stringify(b.quota)}'>Select Bundle</button>
      </div>
    </article>
  `).join('');

  /* ===================================================================
     BUILD-YOUR-BOX picker → adds a flat-price pack product to the Shopify
     cart with the chosen meals recorded as line-item properties.
     >>> Fill PACK_VARIANTS with the "Build Your Box" product's variant IDs. <<<
     =================================================================== */
  const PACK_VARIANTS = { 5: 58151227425071, 10: 58151227457839, 15: 58151227490607, 20: 58151227523375 };
  if (PACKS) Object.keys(PACK_VARIANTS).forEach(k => { if (PACKS[k] && PACKS[k].id) PACK_VARIANTS[k] = PACKS[k].id; });

  /* Custom-mix feature flag (Customize → Aktivate Top → "Customize your mix").
     off (default) = hidden everywhere. preview = only in the theme editor, theme previews and
     `shopify theme dev` (never on the published theme). live = also on the published theme, but
     ONLY once aktivate-mix-pricing.js has an approved resolver — so pending pricing can't go public. */
  const MIX = window.AKTIVATE_MIX || {};
  const themeRole = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  const mixPricingReady = () => { const P = window.AKTIVATE_MIX_PRICING || {}; return typeof P.resolve === 'function' && P.ready !== false; };
  const MIX_ON = MIX.mode === 'preview' ? (!!MIX.designMode || (themeRole !== '' && themeRole !== 'main'))
    : MIX.mode === 'live' ? (themeRole !== 'main' || mixPricingReady()) : false;
  // Price for an altered mix. Rules live ONLY in aktivate-mix-pricing.js; anything it can't price
  // comes back 'unconfigured' (blocks the cart). adjustmentCents 0 = an approved, valid $0 change.
  function quoteMix(ctx) {
    const P = window.AKTIVATE_MIX_PRICING || {};
    if (typeof P.resolve !== 'function') return { status: 'unconfigured' };
    let q; try { q = P.resolve(ctx); } catch (_) { return { status: 'unconfigured' }; }
    if (!q || q.status !== 'priced' || !Number.isInteger(q.adjustmentCents)) return { status: 'unconfigured' };
    const lines = (Array.isArray(q.lines) ? q.lines : []).filter(l => l && Number(l.id) > 0 && Number.isInteger(l.quantity) && l.quantity > 0)
      .map(l => ({ id: Number(l.id), quantity: l.quantity, properties: { '_mix_adjustment': 'true' } }));
    // a non-zero adjustment must be charged by Shopify-priced lines; the browser total is never trusted
    if (q.adjustmentCents !== 0 && !lines.length) return { status: 'unconfigured' };
    return { status: 'priced', adjustmentCents: q.adjustmentCents, lines };
  }

  (function () {
    const bg = document.getElementById('bundlesGrid');
    if (!bg) return;
    const scrim = document.createElement('div');
    scrim.className = 'box-scrim'; scrim.id = 'boxScrim';
    scrim.innerHTML = `
      <aside class="box-picker" role="dialog" aria-modal="true" aria-label="Build your box">
        <div class="box-head">
          <div><div class="box-title" id="boxTitle">Build Your Box</div><div class="box-sub" id="boxSub"></div></div>
          <button class="box-close" id="boxClose" aria-label="Close">&times;</button>
        </div>
        <div class="box-tabs-wrap" id="boxTabsWrap" hidden>
          <div class="box-tabs" role="tablist" aria-label="Bundle type">
            <button class="box-tab on" type="button" role="tab" id="boxTabDefault" data-mode="default" aria-selected="true" aria-controls="boxGrid">Default bundle</button>
            <button class="box-tab" type="button" role="tab" id="boxTabCustom" data-mode="custom" aria-selected="false" aria-controls="boxGrid" tabindex="-1">Customize</button>
          </div>
          <p class="box-tab-hint" id="boxTabHint" aria-live="polite"></p>
        </div>
        <div class="box-grid" id="boxGrid"></div>
        <div class="box-plans" id="boxPlans" hidden></div>
        <p class="box-notice" id="boxNotice" aria-live="polite" hidden></p>
        <div class="box-foot">
          <div class="box-progress" id="boxProgress"></div>
          <button class="box-add" id="boxAdd" disabled>Add to Cart</button>
        </div>
      </aside>`;
    document.body.appendChild(scrim);
    const boxGrid = scrim.querySelector('#boxGrid');
    const boxAdd = scrim.querySelector('#boxAdd');
    const boxProgress = scrim.querySelector('#boxProgress');
    const boxPlans = scrim.querySelector('#boxPlans');
    const boxNotice = scrim.querySelector('#boxNotice');
    const tabsWrap = scrim.querySelector('#boxTabsWrap'), tabHint = scrim.querySelector('#boxTabHint');
    const tabs = [...scrim.querySelectorAll('.box-tab')];
    let packSize = 0, packPrice = '', packName = '', packQuota = {}, selected = [];
    let packPlan = null; // chosen selling plan for this pack (null = one-time)
    const catLabels = {};
    // Customize tab (feature-flagged, see MIX_ON): packQuota stays the bundle's default mix. In
    // 'custom' mode only the total is capped, and every meal past a category's default count is an
    // upcharge (priced by aktivate-mix-pricing.js). Switching tabs never drops picks.
    let mode = 'default', catOrder = [];

    // Subscription is bundles-only: the pack variant's selling plans (if any) come from
    // window.AKTIVATE_PACKS. No plan attached -> no toggle, pack stays one-time.
    const plansFor = size => ((PACKS && PACKS[String(size)] && PACKS[String(size)].plans) || []).filter(p => p && p.id);
    function renderPlans() {
      const plans = plansFor(packSize);
      if (!plans.length) { boxPlans.hidden = true; boxPlans.innerHTML = ''; packPlan = null; return; }
      // subscription first (it's the default when a pack opens); one-time stays one tap away
      boxPlans.innerHTML = plans.map(p => `
        <button class="box-plan${packPlan === p.id ? ' on' : ''}" type="button" data-plan="${p.id}" aria-pressed="${packPlan === p.id}">
          <span class="bp-name">${escHtml(p.name)}</span>
          <span class="bp-price">${p.was && p.was !== p.price ? `<s>${escHtml(p.was)}</s> ` : ''}${escHtml(p.price)}</span>
        </button>`).join('') + `
        <button class="box-plan${packPlan === null ? ' on' : ''}" type="button" data-plan="" aria-pressed="${packPlan === null}">
          <span class="bp-name">One-time</span><span class="bp-price">${escHtml(packPrice)}</span>
        </button>`;
      boxPlans.hidden = false;
    }
    boxPlans.addEventListener('click', e => {
      const b = e.target.closest('.box-plan'); if (!b) return;
      packPlan = b.dataset.plan ? Number(b.dataset.plan) : null;
      renderPlans(); renderState();
    });

    // meals eligible for THIS pack = only categories that are in the pack's quota (dessert etc. excluded)
    const meals = () => [...document.querySelectorAll('#grid .card')].map(c => ({
      name: (c.querySelector('.card-name') || {}).textContent || '',
      img: (c.querySelector('.card-img img') || {}).src || '',
      c: c.dataset.c || '',
      label: (c.querySelector('.card-cat') || {}).textContent || c.dataset.c || ''
    })).filter(m => m.name && packQuota[m.c] != null);

    const countOf = cat => selected.filter(s => s.c === cat).length;
    const extraOf = cat => Math.max(0, countOf(cat) - (packQuota[cat] || 0));
    const currentMix = () => Object.keys(packQuota).reduce((m, c) => (m[c] = countOf(c), m), {});
    const packCents = () => Math.round(parseFloat(String(packPrice).replace(/[^0-9.]/g, '')) * 100) || 0;
    const mixQuote = m => quoteMix({ meals: packSize, name: packName, variantId: PACK_VARIANTS[packSize], price: packPrice,
      recommended: { ...packQuota }, mix: { ...m },
      delta: Object.keys(packQuota).reduce((d, c) => (d[c] = (m[c] || 0) - packQuota[c], d), {}) });
    // "+$3" for one extra meal of a category (priced per category in aktivate-mix-pricing.js)
    const upLabel = cat => { const P = window.AKTIVATE_MIX_PRICING || {}; const c = typeof P.centsFor === 'function' ? P.centsFor(cat) : null;
      return Number.isInteger(c) ? `+${money(c).replace('.00', '')}` : '+ upcharge'; };

    function renderState() {
      const cats = Object.keys(packQuota);
      const custom = mode === 'custom';
      const extras = custom ? cats.reduce((n, c) => n + extraOf(c), 0) : 0;
      const full = selected.length >= packSize;
      const allMet = custom ? selected.length === packSize : cats.every(cat => countOf(cat) === packQuota[cat]);
      // a mix past the defaults may only be bought once the pricing module can price it
      const quote = extras ? mixQuote(currentMix()) : null;
      const pending = !!quote && quote.status !== 'priced';
      boxAdd.disabled = !allMet || pending;
      const chosen = packPlan ? plansFor(packSize).find(p => p.id === packPlan) : null;
      const priceLabel = chosen ? chosen.price : packPrice;
      const total = quote && !pending ? money(packCents() + quote.adjustmentCents) : priceLabel;
      boxAdd.textContent = !allMet ? `${selected.length} / ${packSize} selected`
        : pending ? 'Custom mix pricing is pending' : `Add ${packSize} Meals — ${total}`;
      boxProgress.innerHTML = cats.map(cat => {
        const n = countOf(cat), q = packQuota[cat];
        if (custom) return `<span class="box-chip${n ? ' done' : ''}${extraOf(cat) ? ' up' : ''}">${catLabels[cat] || cat} ${n}${extraOf(cat) ? ` · ${extraOf(cat)}× ${upLabel(cat)}` : ''}</span>`;
        return `<span class="box-chip${n === q ? ' done' : ''}${n > q ? ' over' : ''}">${catLabels[cat] || cat} ${n}/${q}</span>`;
      }).join('');
      // back on the default tab with picks past the defaults: keep them, but say exactly what to remove
      const over = custom ? [] : cats.filter(cat => countOf(cat) > packQuota[cat]).map(cat => {
        const n = countOf(cat) - packQuota[cat];
        return `${n} ${catLabels[cat] || cat} meal${n > 1 ? 's' : ''}`;
      });
      boxNotice.textContent = over.length ? `The default bundle has fewer of these — remove ${over.join(' and ')}, or switch to Customize.` : '';
      boxNotice.hidden = !over.length;
      if (extras) boxPlans.hidden = true; // pack plans are priced for the default mix only
      else if (plansFor(packSize).length) boxPlans.hidden = false;
      tabHint.textContent = !custom ? '' : full ? 'Remove a meal to make room for a swap.'
        : `Pick any ${packSize} meals. Each meal past a category's included amount is extra: ${catOrder.map(c => `${catLabels[c] || c} ${upLabel(c)}`).join(' · ')}.`;
      tabHint.hidden = !custom;
      scrim.querySelector('#boxSub').textContent = (custom ? cats.map(c => countOf(c) + ' ' + (catLabels[c] || c)).join(' · ') + ' · ' + (pending ? 'price pending' : total)
        : catOrder.map(c => packQuota[c] + ' ' + (catLabels[c] || c)).join(' · ') + ' · ' + packPrice);
      boxGrid.querySelectorAll('.box-cat-head[data-c]').forEach(h => {
        const c = h.dataset.c, q = packQuota[c] || 0;
        h.querySelector('span').textContent = custom ? `${Math.min(countOf(c), q)}/${q} included · ${extraOf(c) ? `${extraOf(c)} extra` : 'extras'} ${upLabel(c)}` : `pick ${q}`;
      });
      [...boxGrid.querySelectorAll('.box-item')].forEach(el => {
        const nm = el.dataset.name, ct = el.dataset.c;
        const count = selected.filter(s => s.name === nm && s.c === ct).length;
        const capped = custom ? full : countOf(ct) >= packQuota[ct];
        const upNext = custom && !full && countOf(ct) >= packQuota[ct]; // the next one of these costs extra
        el.classList.toggle('sel', count > 0);
        el.classList.toggle('cat-full', count === 0 && capped);
        el.classList.toggle('upcharge', upNext);
        const badge = el.querySelector('.box-up');
        if (badge) { badge.hidden = !upNext; badge.textContent = upLabel(ct); }
        const addLbl = upNext ? `Add one, ${upLabel(ct)} upcharge` : (count ? 'Add one' : 'Add');
        const step = el.querySelector('.box-stepper');
        if (count === 0) {
          step.innerHTML = `<button class="box-step" type="button" data-step="inc" aria-label="${addLbl}"${capped ? ' disabled' : ''}>+</button>`;
        } else {
          step.innerHTML = `<button class="box-step" type="button" data-step="dec" aria-label="Remove one">&minus;</button>`
            + `<span class="box-qty">${count}</span>`
            + `<button class="box-step" type="button" data-step="inc" aria-label="${addLbl}"${capped ? ' disabled' : ''}>+</button>`;
        }
      });
    }

    function setMode(m, focus) {
      mode = MIX_ON && m === 'custom' ? 'custom' : 'default';
      tabs.forEach(t => { const on = t.dataset.mode === mode; t.classList.toggle('on', on); t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      renderState();
    }
    tabs.forEach(t => t.addEventListener('click', () => setMode(t.dataset.mode)));
    tabsWrap.addEventListener('keydown', e => { // arrow keys move between the two tabs
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault(); setMode(mode === 'custom' ? 'default' : 'custom', true);
    });

    function open(size, price, name, quota) {
      packSize = size; packPrice = price; packName = name; packQuota = quota || {}; selected = [];
      packPlan = (plansFor(size)[0] || {}).id || null; // subscription is the default; One-time is a tap away
      renderPlans();
      const list = meals();
      list.forEach(m => { if (!catLabels[m.c]) catLabels[m.c] = m.label; });
      const order = [];
      list.forEach(m => { if (!order.includes(m.c)) order.push(m.c); });
      catOrder = order;
      tabsWrap.hidden = !MIX_ON;
      scrim.querySelector('#boxTitle').textContent = name;
      boxGrid.innerHTML = order.map(cat => {
        const head = `<div class="box-cat-head" data-c="${cat}">${catLabels[cat] || cat}<span>pick ${packQuota[cat]}</span></div>`;
        const cards = list.filter(m => m.c === cat).map(m => `
          <div class="box-item" data-name="${m.name.replace(/"/g, '&quot;')}" data-c="${cat}">
            <span class="box-thumb"${m.img ? ` style="background-image:url('${m.img}')"` : ''}></span>
            <span class="box-item-name">${m.name}</span>
            ${MIX_ON ? '<span class="box-up" hidden></span>' : ''}
            <span class="box-stepper"></span>
          </div>`).join('');
        return head + cards;
      }).join('');
      setMode('default');
      scrim.classList.add('open'); document.body.style.overflow = 'hidden';
    }
    const close = () => { scrim.classList.remove('open'); document.body.style.overflow = ''; };

    boxGrid.addEventListener('click', e => {
      const step = e.target.closest('.box-step'); if (!step) return;
      const it = step.closest('.box-item'); if (!it) return;
      const n = it.dataset.name, cat = it.dataset.c;
      if (step.dataset.step === 'inc') {
        const room = mode === 'custom' ? selected.length < packSize : countOf(cat) < packQuota[cat];
        if (room) selected.push({ name: n, c: cat });
      } else {
        for (let i = selected.length - 1; i >= 0; i--) {
          if (selected[i].name === n && selected[i].c === cat) { selected.splice(i, 1); break; }
        }
      }
      renderState();
    });
    bg.addEventListener('click', e => {
      const b = e.target.closest('.b-btn[data-pack]'); if (!b) return;
      let quota = {}; try { quota = JSON.parse(b.dataset.packQuota || '{}'); } catch (_) {}
      open(parseInt(b.dataset.pack, 10), b.dataset.packPrice, b.dataset.packName, quota);
    });
    scrim.querySelector('#boxClose').addEventListener('click', close);
    scrim.addEventListener('click', e => { if (e.target === scrim) close(); });
    boxAdd.addEventListener('click', () => {
      const vid = PACK_VARIANTS[packSize];
      const props = {}; selected.forEach((s, i) => props['Meal ' + (i + 1)] = s.name);
      if (!vid) { alert('Pack product not connected yet — add the Build Your Box variant IDs to enable checkout.'); return; }
      const cats = Object.keys(packQuota);
      const custom = mode === 'custom';
      if (custom ? selected.length !== packSize : !cats.every(c => countOf(c) === packQuota[c])) return;
      // a mix past the defaults never reaches the cart without an approved price (re-checked here, not just via the disabled button)
      const extras = custom ? cats.reduce((n, c) => n + extraOf(c), 0) : 0;
      const mix = currentMix();
      const quote = extras ? mixQuote(mix) : null;
      if (quote && quote.status !== 'priced') return;
      if (quote) {
        props['Mix'] = catOrder.map(c => mix[c] + ' ' + (catLabels[c] || c)).join(' · ');
        props['_mix'] = JSON.stringify(mix); // machine-readable, hidden at checkout — for order handling / server validation
        props['_mix_upgrades'] = String(quote.lines.reduce((n, l) => n + l.quantity, 0)); // upgrade lines this pack needs
        // exactly which upgrade variants (per category) and how many — the cart checks these line by line
        props['_mix_upgrade_lines'] = JSON.stringify(quote.lines.reduce((o, l) => (o[l.id] = (o[l.id] || 0) + l.quantity, o), {}));
      }
      const item = { id: Number(vid), quantity: 1, properties: props };
      if (packPlan && !quote) item.selling_plan = packPlan; // bundle subscription (bundles-only by design)
      boxAdd.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item, ...(quote ? quote.lines : [])] }) })
        .then(r => r.json().then(d => ({ ok: r.ok, d })))
        .then(({ ok, d }) => {
          boxAdd.disabled = false;
          if (!ok) { alert((d && (d.description || d.message)) || 'Could not add this pack to cart.'); return; }
          close(); if (typeof refreshCart === 'function') refreshCart(); if (typeof openCart === 'function') openCart();
        })
        .catch(() => { boxAdd.disabled = false; alert('Could not add this pack to cart.'); });
    });
  })();

  /* ===================================================================
     COUNTDOWN — auto-calculates time to the next Friday 3:00 PM cutoff
     =================================================================== */
  function nextFridayCutoff() {
    const now = new Date();
    const t = new Date(now);
    t.setDate(now.getDate() + ((5 - now.getDay() + 7) % 7)); // 5 = Friday
    t.setHours(15, 0, 0, 0);                                  // 3:00 PM
    if (t <= now) t.setDate(t.getDate() + 7);                 // past cutoff → next Friday
    return t;
  }
  function renderCountdown() {
    const el = document.getElementById('cdTime');
    if (!el) return;
    let diff = Math.max(0, nextFridayCutoff() - new Date());
    const d = Math.floor(diff / 86400000); diff -= d * 86400000;
    const h = Math.floor(diff / 3600000);  diff -= h * 3600000;
    const m = Math.floor(diff / 60000);    diff -= m * 60000;
    const s = Math.floor(diff / 1000);
    el.innerHTML = `<b>${d}</b>d <b>${h}</b>h <b>${m}</b>m <b>${String(s).padStart(2,'0')}</b>s`;
  }
  renderCountdown();
  setInterval(renderCountdown, 1000);

  /* keep the hero clear of the fixed header (countdown + nav) at any size */
  function setTopH() {
    const st = document.getElementById('siteTop');
    if (st) document.documentElement.style.setProperty('--top-h', st.offsetHeight + 'px');
  }
  setTopH();
  window.addEventListener('resize', setTopH);
  window.addEventListener('load', setTopH);

  /* ===== TRUST MARQUEE ===== */
  // Items come from the theme editor (Aktivate Top → Trust marquee, via window.AKTIVATE_MARQUEE);
  // the literal list is only the fallback if that setting is somehow blank.
  let tItems = ['Chef-Made','100% Halal Certified','Fresh Weekly','Never Frozen','No Commitment','High Protein','New Jersey Grown'];
  const mqSet = (window.AKTIVATE_MARQUEE || []).map(s => String(s).trim()).filter(Boolean);
  if (mqSet.length) tItems = mqSet;
  const marqEl = document.getElementById('marq');
  if (marqEl) marqEl.innerHTML =
    [...tItems, ...tItems].map(t => `<span class="marq-item"><span class="marq-dot"></span>${escHtml(t)}</span>`).join('');

  /* ===== LEAD GEN ===== */
  /* store an email in Shopify Customers via the hidden native customer form (fire-and-forget) */
  function captureEmail(email, tags) {
    const form = document.getElementById('aktivateCaptureForm');
    if (!form) return;
    form.querySelector('#captureEmail').value = email;
    form.querySelector('#captureTags').value = tags;
    fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(() => {});
  }
  const leadBtnEl = document.getElementById('leadBtn');
  if (leadBtnEl) leadBtnEl.addEventListener('click', () => {
    const el = document.getElementById('leadEmail');
    if (!el.value.trim().includes('@')) { el.style.borderColor = '#E08A8A'; return; }
    captureEmail(el.value.trim(), 'expansion-waitlist, source-homepage');
    const btn = document.getElementById('leadBtn');
    btn.textContent = "✓ You're on the list!";
    btn.style.background = '#3E7A4E'; btn.disabled = true;
    el.disabled = true;
  });

  /* ===================================================================
     ZIP CHECKER MODAL
     =================================================================== */
  const scrim   = document.getElementById('zipScrim');
  const zModal  = document.getElementById('zipModal');
  const zField  = document.getElementById('zipField');
  const zGo     = document.getElementById('zipGo');
  const zErr    = document.getElementById('zipErr');
  const zResult = document.getElementById('zipResult');
  let lastFocus = null;
  // Editable zip-checker copy (Theme settings → Zip checker). "{zip}" = the customer's zip.
  const ZT = (window.AKTIVATE_TEXT && window.AKTIVATE_TEXT.zip) || {};
  const zfill = (s, fallback, z) => escHtml(s || fallback).replace('{zip}', z);

  function openZip() {
    lastFocus = document.activeElement;
    resetZip();
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => zField.focus(), 350);
  }
  function closeZip() {
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function resetZip() {
    zField.value = ''; zErr.textContent = ''; zResult.innerHTML = '';
    zGo.disabled = false; zGo.textContent = ZT.button || 'Check';
    document.querySelector('.modal-form').style.display = '';
  }

  // open triggers
  document.querySelectorAll('[data-zip]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openZip(); });
  });
  document.getElementById('zipClose').addEventListener('click', closeZip);
  scrim.addEventListener('click', e => { if (e.target === scrim) closeZip(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && scrim.classList.contains('open')) closeZip(); });

  // delivery zones: all NJ (07/08) + Rockland NY (109xx), plus individual zips from
  // Theme settings → Zip checker → "Additional zip codes" (Manhattan etc.)
  const extraZips = new Set(String(ZT.extra || '').match(/\d{5}/g) || []);
  function isServiced(z) { return /^(07|08|109)/.test(z) || extraZips.has(z); }

  function runCheck() {
    const z = zField.value.trim();
    zErr.textContent = '';
    if (!/^\d{5}$/.test(z)) { zErr.textContent = ZT.invalid || 'Please enter a valid 5-digit zip code.'; zField.focus(); return; }

    zGo.disabled = true; zGo.innerHTML = '<span class="spin"></span>';
    setTimeout(() => {
      // hide the input row, show result
      document.querySelector('.modal-form').style.display = 'none';
      if (isServiced(z)) {
        zResult.innerHTML = `
          <div class="modal-state ok">
            <div class="ms-head">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              ${zfill(ZT.okHead, 'Great news — we deliver to {zip}!', z)}
            </div>
            <p class="ms-sub">${zfill(ZT.okSub, "Fresh, chef-made meals delivered right to your door. Let's build your first box.", z)}</p>
            <a href="#bundles" class="ms-cta" id="msStart">
              ${escHtml(ZT.okCta || 'Choose Your Bundle')}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </a>
          </div>`;
        document.getElementById('msStart').addEventListener('click', closeZip);
      } else {
        zResult.innerHTML = `
          <div class="modal-state expand">
            <div class="ms-head">${zfill(ZT.noHead, "We're not in {zip}", z)} <em style="font-style:italic;font-weight:400;color:var(--muted);margin-left:4px;">${escHtml(ZT.noTail || '— yet.')}</em></div>
            <p class="ms-sub">${zfill(ZT.noSub, "We're expanding fast. Drop your email and you'll be first to know when Aktivate reaches your area — plus an exclusive first-order offer.", z)}</p>
            <div class="ms-expand-form">
              <input class="modal-input" id="expandEmail" type="email" placeholder="${escHtml(ZT.emailPlaceholder || 'Enter your email address')}" autocomplete="email" aria-label="Email address" />
              <button class="modal-btn" id="expandGo" style="width:100%;">${escHtml(ZT.notify || 'Notify Me When We Expand')}</button>
            </div>
          </div>`;
        const eIn = document.getElementById('expandEmail');
        const eGo = document.getElementById('expandGo');
        setTimeout(() => eIn.focus(), 100);
        function submitExpand() {
          if (!eIn.value.trim().includes('@')) { eIn.style.borderColor = '#C0563C'; eIn.focus(); return; }
          captureEmail(eIn.value.trim(), 'expansion-waitlist, zip-' + z);
          document.querySelector('.modal-state.expand').innerHTML = `
            <div class="ms-head" style="color:var(--brand);">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              ${escHtml(ZT.doneHead || "You're on the list!")}
            </div>
            <p class="ms-sub">${zfill(ZT.doneSub, "Thanks — we'll email you the moment Aktivate Kitchen launches in {zip}. Keep an eye on your inbox for your welcome offer.", z)}</p>`;
        }
        eGo.addEventListener('click', submitExpand);
        eIn.addEventListener('keydown', ev => { if (ev.key === 'Enter') submitExpand(); });
      }
    }, 850);
  }

  zGo.addEventListener('click', runCheck);
  zField.addEventListener('keydown', e => { if (e.key === 'Enter') runCheck(); });
  zField.addEventListener('input', () => { zField.value = zField.value.replace(/\D/g, '').slice(0,5); });

  /* ===================================================================
     HAMBURGER NAV DRAWER + CART
     =================================================================== */
  const navScrim   = document.getElementById('navScrim');
  const cartScrim  = document.getElementById('cartScrim');
  const hamBadge   = document.getElementById('hamBadge');

  function openDrawer(el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(el) { el.classList.remove('open'); document.body.style.overflow = ''; }

  // hamburger
  const hamBtn = document.getElementById('hamBtn');
  hamBtn.addEventListener('click', () => { openDrawer(navScrim); hamBtn.setAttribute('aria-expanded','true'); });
  document.getElementById('navDrawerClose').addEventListener('click', () => { closeDrawer(navScrim); hamBtn.setAttribute('aria-expanded','false'); });
  navScrim.addEventListener('click', e => { if (e.target === navScrim) { closeDrawer(navScrim); hamBtn.setAttribute('aria-expanded','false'); } });
  // nav drawer links: close drawer, let anchor scroll
  document.querySelectorAll('[data-navlink]').forEach(a => {
    a.addEventListener('click', () => { closeDrawer(navScrim); hamBtn.setAttribute('aria-expanded','false'); });
  });

  // cart open/close
  function openCart() {
    closeDrawer(navScrim); openDrawer(cartScrim);
    // reopening the drawer brings the add-on strip back (it can be ✕'d again)
    if (upsellDismissed) { upsellDismissed = false; if (lastCart) renderUpsell(lastCart); }
  }
  document.getElementById('openCartFromNav').addEventListener('click', openCart);
  const navCart = document.getElementById('navCart');
  if (navCart) navCart.addEventListener('click', e => { e.preventDefault(); openCart(); });
  document.getElementById('cartClose').addEventListener('click', () => closeDrawer(cartScrim));
  cartScrim.addEventListener('click', e => { if (e.target === cartScrim) closeDrawer(cartScrim); });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (navScrim.classList.contains('open')) closeDrawer(navScrim);
    if (cartScrim.classList.contains('open')) closeDrawer(cartScrim);
  });

  /* ----- cart (Shopify AJAX cart -> native hosted checkout) ----- */
  const money = c => '$' + (c / 100).toFixed(2);
  function updateCount(n) {
    document.querySelectorAll('.cart-count-val').forEach(el => el.textContent = n);
    const hb = document.getElementById('hamBadge');
    if (hb) { hb.textContent = n; hb.classList.toggle('show', n > 0); }
    // header cart icon (top right): count badge + a label that says the count to screen readers
    const cb = document.getElementById('navCartBadge'), nc = document.getElementById('navCart');
    if (cb) { cb.textContent = n > 99 ? '99+' : n; cb.classList.toggle('show', n > 0); }
    if (nc) nc.setAttribute('aria-label', `Cart, ${n} item${n === 1 ? '' : 's'}`);
  }
  let lastCart = null; // latest /cart.js state — lets the upsell steppers find a line by variant id
  function renderCart(cart) {
    lastCart = cart;
    updateCount(cart.item_count);
    const wrap = document.getElementById('cartItems');
    if (!cart.items.length) {
      const T = window.AKTIVATE_TEXT || {}; // editable: Theme settings → Cart text
      wrap.innerHTML = `<div class="cart-empty">${escHtml(T.emptyTitle || 'Your cart is empty.')}<br>${escHtml(T.emptySub || 'Add a few meals to get started.')}</div>`;
    } else {
      wrap.innerHTML = cart.items.map(i => {
        const unit = i.properties && i.properties['Sold by'];            // legacy per-lb lines
        const size = i.gift_card ? '' // gift card variant titles are just the amount ("$50.00")
          : (i.properties && i.properties['Size']) || (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '');
        const qtyText = unit ? `${i.quantity} ${unit}` : `${i.quantity}`;
        const priceText = unit ? `${money(i.final_price)} / ${unit}` : (size ? `${money(i.final_price)} · ${escHtml(size)}` : `${money(i.final_price)} each`);
        const plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.name;
        // automatic discounts (e.g. "buy 2 desserts get 1 free") land in line_level_discount_allocations
        const discs = (i.line_level_discount_allocations || []).map(d =>
          `<div class="cart-row-disc">${escHtml((d.discount_application && d.discount_application.title) || 'Discount')} (&minus;${money(d.amount)})</div>`).join('');
        const struck = i.original_line_price !== i.final_line_price
          ? ` <s class="cart-row-was">${money(i.original_line_price)}</s>` : '';
        // digital gift card: say where Shopify will email it (recipient properties, else the buyer)
        const giftTo = i.gift_card ? `<div class="cart-row-gift">${i.properties && i.properties['Recipient email']
          ? `Emailed to ${escHtml(i.properties['Recipient email'])}` : 'Emailed to you after checkout'}</div>` : '';
        return `
        <div class="cart-row" data-row-key="${i.key}">
          <div class="cart-row-info">
            <div class="cart-row-name">${escHtml(i.product_title)}</div>
            <div class="cart-row-price">${priceText}${struck}</div>
            ${plan ? `<div class="cart-row-plan">${escHtml(plan)}</div>` : ''}
            ${giftTo}
            ${discs}
          </div>
          <div class="cart-qty">
            <button data-key="${i.key}" data-qty="${i.quantity - 1}" aria-label="Decrease">-</button>
            <span>${qtyText}</span>
            <button data-key="${i.key}" data-qty="${i.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>`;
      }).join('');
    }
    const saved = document.getElementById('cartSaved');
    if (saved) {
      if (cart.total_discount > 0) { saved.innerHTML = `You saved <strong>${money(cart.total_discount)}</strong>`; saved.hidden = false; }
      else saved.hidden = true;
    }
    document.getElementById('cartSubtotal').textContent = money(cart.total_price);
    // a custom-mix pack must not check out if its pricing isn't configured (e.g. rules rolled back) or
    // its upgrade lines were changed separately in the cart: per upgrade variant, pack qty x that
    // pack's upgrades must match the cart exactly (packs added before per-category pricing carry only
    // a total count, `_mix_upgrades`, so those are matched on the total)
    const prop = (i, k) => (i.properties && i.properties[k]) || '';
    const hasMix = cart.items.some(i => prop(i, '_mix'));
    const needUp = {}, haveUp = {}; let legacyUp = 0;
    cart.items.forEach(i => {
      if (prop(i, '_mix')) {
        let ul = null; try { ul = JSON.parse(prop(i, '_mix_upgrade_lines') || 'null'); } catch (_) {}
        if (ul && typeof ul === 'object') Object.entries(ul).forEach(([v, q]) => { needUp[v] = (needUp[v] || 0) + i.quantity * q; });
        else legacyUp += i.quantity * (parseInt(prop(i, '_mix_upgrades'), 10) || 0);
      }
      if (prop(i, '_mix_adjustment')) haveUp[i.variant_id] = (haveUp[i.variant_id] || 0) + i.quantity;
    });
    const sum = o => Object.values(o).reduce((n, q) => n + q, 0);
    const mixMismatch = legacyUp ? sum(needUp) + legacyUp !== sum(haveUp)
      : [...new Set([...Object.keys(needUp), ...Object.keys(haveUp)])].some(v => (needUp[v] || 0) !== (haveUp[v] || 0));
    const mixUnpriced = hasMix && !mixPricingReady();
    const mixHold = mixUnpriced || mixMismatch;
    document.getElementById('cartCheckout').disabled = cart.item_count === 0 || mixHold;
    document.querySelectorAll('.cartpage-cta').forEach(a => { a.toggleAttribute('aria-disabled', mixHold); a.classList.toggle('mix-hold', mixHold); });
    let holdNote = document.getElementById('cartMixHold');
    if (mixHold && !holdNote) {
      holdNote = document.createElement('p'); holdNote.id = 'cartMixHold'; holdNote.className = 'cart-mix-hold';
      document.getElementById('cartCheckout').insertAdjacentElement('beforebegin', holdNote);
    }
    if (holdNote) {
      holdNote.textContent = mixUnpriced ? 'Custom mix pricing is pending — remove the custom mix pack to check out.'
        : 'Your custom mix upgrades don’t match your bundles — remove the custom bundle and its upgrades, then add it again.';
      holdNote.hidden = !mixHold;
    }
    renderUpsell(cart);
    renderSurvey(cart);
    renderAllergy(cart);
    updatePrepBar(cart);
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json()).then(renderCart);
  }
  function addVariant(id, props, sellingPlan) {
    const item = { id: Number(id), quantity: 1 };
    if (props) item.properties = props;
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) }).then(() => refreshCart());
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(r => r.json()).then(renderCart);
  }

  /* ----- "How did you hear about us?" — saved as a native cart attribute, so it lands on the
     order in admin (Additional details) and in the order CSV. Optional by design. ----- */
  // delegated: the drawer and the /cart page each render their own .cs-select on the same page
  document.addEventListener('change', e => {
    const sel = e.target.closest('.cs-select'); if (!sel) return;
    const key = (sel.getAttribute('name') || '').replace(/^attributes\[|\]$/g, ''); if (!key) return;
    const ok = sel.parentElement.querySelector('.cs-ok');
    sel.disabled = true;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [key]: sel.value } }) })
      .then(() => {
        sel.disabled = false;
        // keep the other surface's copy in sync
        document.querySelectorAll('.cs-select').forEach(o => { if (o !== sel && o.getAttribute('name') === sel.getAttribute('name')) o.value = sel.value; });
        if (ok && sel.value) { ok.hidden = false; setTimeout(() => { ok.hidden = true; }, 1800); }
      })
      .catch(() => { sel.disabled = false; });
  });
  function renderSurvey(cart) {
    const wrap = document.getElementById('cartSurvey'), sel = document.getElementById('cartSurveySel');
    if (!wrap || !sel) return;
    if (!cart.items.length) { wrap.hidden = true; return; }
    const key = sel.getAttribute('name').replace(/^attributes\[|\]$/g, '');
    const saved = cart.attributes && cart.attributes[key];
    if (saved && sel.value !== saved) sel.value = saved; // survive a reload / reopened drawer
    wrap.hidden = false;
  }
  /* ----- ALLERGIES: the cart's "Any food allergies?" dropdown (snippets/aktivate-allergy-picker).
     The choice is the cart attribute "Allergies" (shows on the order under Additional details).
     Every cart meal that lists a chosen allergen (assets/aktivate-allergens.js) gets a red "!" and
     is written to the "Allergy alerts" attribute so the kitchen sees it on the order too. Bundles
     are checked meal by meal ("Meal 1", "Meal 2"… properties). ----- */
  const ALG = window.AKTIVATE_ALLERGENS || null;
  const ALG_KEY = 'Allergies', ALG_ALERT_KEY = 'Allergy alerts';
  const algNorm = s => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const algByTitle = (() => {
    const m = {};
    if (ALG) Object.entries(ALG.meals || {}).forEach(([h, d]) => { if (d.t) m[algNorm(d.t)] = h; });
    return m;
  })();
  const algLabel = id => (ALG && ALG.labels[id]) || id;
  // "Milk, Eggs, Other: kiwi" <-> { ids: ['milk','egg'], other: 'kiwi' }
  function algParse(str) {
    const out = { ids: [], other: '' };
    String(str || '').split(/,\s*/).forEach(part => {
      if (/^other:/i.test(part)) { out.other = part.replace(/^other:\s*/i, ''); return; }
      const id = ALG && Object.keys(ALG.labels).find(k => algNorm(ALG.labels[k]) === algNorm(part));
      if (id) out.ids.push(id);
    });
    return out;
  }
  const algFormat = sel => [...sel.ids.map(algLabel), ...(sel.other ? ['Other: ' + sel.other] : [])].join(', ');
  // the meals in a cart line → [{ meal, allergens }]; unknown meals are skipped (no data, no flag)
  function algMealsOf(item) {
    const props = item.properties || {};
    const names = Object.keys(props).filter(k => /^Meal \d+$/.test(k)).map(k => props[k]);
    const lookup = (handle, title) => (ALG.meals[handle] || ALG.meals[algByTitle[algNorm(title)]] || null);
    if (names.length) return names.map(n => ({ meal: n, d: lookup(null, n) })).filter(x => x.d);
    const d = lookup(item.handle, item.product_title);
    return d ? [{ meal: item.product_title, d }] : [];
  }
  function algConflicts(item, ids) {
    const hits = {};
    algMealsOf(item).forEach(({ meal, d }) => {
      const a = (d.a || []).filter(x => ids.includes(x));
      if (a.length) hits[meal] = a;
    });
    return hits; // { meal name: [allergen ids] }
  }
  let algSaving = false;
  function renderAllergy(cart) {
    const widgets = [...document.querySelectorAll('[data-allergy]')];
    if (!ALG || !widgets.length) return;
    const sel = algParse(cart.attributes && cart.attributes[ALG_KEY]);
    widgets.forEach(w => {
      w.hidden = !cart.items.length;
      const opts = w.querySelector('.ca-opts');
      if (!opts.children.length) opts.innerHTML = ALG.options.map(id =>
        `<label class="ca-opt"><input type="checkbox" value="${id}"><span>${escHtml(algLabel(id))}</span></label>`).join('');
      opts.querySelectorAll('input').forEach(cb => { cb.checked = sel.ids.includes(cb.value); });
      const other = w.querySelector('.ca-other');
      if (document.activeElement !== other) other.value = sel.other;
      w.querySelector('.ca-summary').textContent = algFormat(sel) || 'None';
    });
    // red "!" on every conflicting line (drawer rows + /cart rows share data-row-key)
    const alerts = [];
    cart.items.forEach(item => {
      const hits = sel.ids.length ? algConflicts(item, sel.ids) : {};
      const meals = Object.keys(hits);
      const text = !meals.length ? '' : (algMealsOf(item).length > 1 || meals[0] !== item.product_title
        ? 'Allergy alert: ' + meals.map(m => `${m} (${hits[m].map(algLabel).join(', ')})`).join(' · ')
        : 'Contains ' + hits[meals[0]].map(algLabel).join(', ') + ' — matches your allergies');
      // order note: "Blackened Salmon (Fish)" or, for a bundle,
      // "Build Your Box — Chef Meal Pack: Blackened Salmon (Fish); Turkey Bolognese (Milk, Wheat)"
      const algList = m => `${m} (${hits[m].map(algLabel).join(', ')})`;
      if (meals.length) alerts.push(meals.length === 1 && meals[0] === item.product_title
        ? algList(meals[0]) : `${item.product_title}: ` + meals.map(algList).join('; '));
      document.querySelectorAll(`[data-row-key="${CSS.escape(item.key)}"]`).forEach(row => {
        row.classList.toggle('alg-conflict', !!meals.length);
        const name = row.querySelector('.cart-row-name');
        let flag = name && name.querySelector('.alg-flag');
        if (meals.length && name && !flag) {
          flag = document.createElement('span'); flag.className = 'alg-flag'; flag.textContent = '!';
          flag.setAttribute('role', 'img'); name.prepend(flag);
        }
        if (flag) { flag.hidden = !meals.length; flag.setAttribute('aria-label', 'Allergy alert'); }
        const info = row.querySelector('.cart-row-info');
        let note = info && info.querySelector('.cart-row-alg');
        if (meals.length && info && !note) { note = document.createElement('div'); note.className = 'cart-row-alg'; info.appendChild(note); }
        if (note) { note.textContent = text; note.hidden = !meals.length; }
      });
    });
    // keep the order's "Allergy alerts" in step with the cart (only write when it actually changed)
    const alertStr = alerts.join(' | ');
    const savedAlert = (cart.attributes && cart.attributes[ALG_ALERT_KEY]) || '';
    if (!algSaving && alertStr !== savedAlert) {
      algSaving = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [ALG_ALERT_KEY]: alertStr } }) })
        .catch(() => {}).then(() => { algSaving = false; });
    }
  }
  function algSave(w) {
    const sel = { ids: [...w.querySelectorAll('.ca-opts input:checked')].map(cb => cb.value), other: w.querySelector('.ca-other').value.trim() };
    w.querySelector('.ca-summary').textContent = algFormat(sel) || 'None';
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ALG_KEY]: algFormat(sel) } }) })
      .then(r => r.json()).then(renderCart).catch(() => {});
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-allergy] .ca-toggle'); if (!t) return;
    const panel = t.parentElement.querySelector('.ca-panel'), open = panel.hidden;
    panel.hidden = !open; t.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('change', e => {
    const w = e.target.closest('[data-allergy]'); if (!w || !e.target.matches('input')) return;
    algSave(w);
  });

  /* ----- add-on offer: dessert picker + "buy N get M free" progress -----
     Offer copy/quantities are theme settings (window.AKTIVATE_OFFER). The actual money is a
     Shopify automatic Buy X Get Y discount created in admin — this UI only surfaces it, so the
     buy/get numbers here must match that discount. Cards use qty steppers (not add-once) so the
     offer threshold is actually reachable from the drawer. */
  const DESSERTS = (window.AKTIVATE_DESSERTS || []).filter(d => d && d.id && d.available);
  const OFFER = window.AKTIVATE_OFFER || null;
  const cartLineFor = vid => ((lastCart && lastCart.items) || []).find(i => i.variant_id === vid) || null;

  /* ----- meal-prep smarts: which prep category (if any) each variant belongs to ----- */
  const PREP = window.AKTIVATE_PREP || null;
  const prepCatOf = (() => {
    const m = {};
    // every size variant of a prep product maps to its category (a 3lb steak is still a protein)
    if (PREP && PREP.cats) Object.keys(PREP.cats).forEach(k => (PREP.cats[k] || []).forEach(it => {
      if (!it) return;
      if (it.id) m[it.id] = k;
      (it.vids || []).forEach(v => { m[v] = k; });
    }));
    return m;
  })();
  // "Complete your meal": cart has prep items -> recommend the categories still missing.
  // Protein in cart -> missing carbs/veg + sauces; carbs/veg but no protein -> proteins first.
  function prepRecs(cart) {
    if (!PREP || !PREP.enabled) return null;
    const cats = PREP.cats || {};
    const have = {};
    cart.items.forEach(i => { const k = prepCatOf[i.variant_id]; if (k) have[k] = true; });
    if (!have.proteins && !have.carbs && !have.veg && !have.sauces) return null;
    let recs = [];
    if (!have.proteins) recs = recs.concat(cats.proteins || []);
    if (!have.carbs) recs = recs.concat(cats.carbs || []);
    if (!have.veg) recs = recs.concat(cats.veg || []);
    if (have.proteins && !have.sauces) recs = recs.concat(cats.sauces || []);
    recs = recs.filter(r => r && r.id && r.available !== false).slice(0, 8);
    return recs.length ? recs : null;
  }
  /* homepage summary bar under the builder grid */
  function updatePrepBar(cart) {
    const bar = document.getElementById('prepBar'), txt = document.getElementById('prepBarText');
    if (!bar || !txt) return;
    let qty = 0, total = 0, lines = 0;
    ((cart && cart.items) || []).forEach(i => {
      if (prepCatOf[i.variant_id]) { lines++; qty += i.quantity; total += i.final_line_price; }
    });
    if (!lines) { bar.hidden = true; return; }
    txt.innerHTML = `Your prep: <b>${qty} item${qty > 1 ? 's' : ''}</b> across ${lines} line${lines > 1 ? 's' : ''} &mdash; <b>${money(total)}</b>`;
    bar.hidden = false;
  }
  (function () {
    const view = document.getElementById('prepBarView');
    if (view) view.addEventListener('click', () => { if (typeof openCart === 'function') openCart(); });
  })();

  /* ===================================================================
     GUIDED MEAL-PREP BUILDER — step-by-step sheet (sibling of the bundle
     box picker, same .box-* shell). Steps = the prep categories that have
     products: Protein -> Carb -> Vegetables -> Sauces (optional). Each item
     has size chips + a qty stepper; the footer adds every picked line to
     the cart in one go. Data: window.AKTIVATE_PREP (Theme settings →
     "Meal prep builder").
     =================================================================== */
  (function () {
    const start = document.getElementById('prepStart');
    if (!start || !PREP || !PREP.cats) return;
    const ORDER = ['proteins', 'carbs', 'veg', 'sauces'];
    const steps = ORDER.filter(k => (PREP.cats[k] || []).some(it => it && it.available !== false));
    if (!steps.length) { start.hidden = true; return; }
    const nameOf = k => (PREP.names && PREP.names[k]) || k;
    const isOptional = k => k === 'sauces';

    const scrim = document.createElement('div');
    scrim.className = 'box-scrim prep-scrim'; scrim.id = 'prepScrim';
    scrim.innerHTML = `
      <aside class="box-picker prep-picker" role="dialog" aria-modal="true" aria-label="Build my meal prep">
        <div class="box-head">
          <div><div class="box-title" id="ppTitle">Build My Meal Prep</div><div class="box-sub" id="ppSub"></div></div>
          <button class="box-close" id="ppClose" aria-label="Close">&times;</button>
        </div>
        <div class="pp-steps" id="ppSteps"></div>
        <div class="box-grid pp-grid" id="ppGrid"></div>
        <div class="box-foot pp-foot">
          <div class="pp-summary" id="ppSummary"></div>
          <div class="pp-nav">
            <button class="pp-back" id="ppBack" type="button">Back</button>
            <button class="box-add" id="ppNext" type="button">Next</button>
          </div>
        </div>
      </aside>`;
    document.body.appendChild(scrim);
    const $ = id => scrim.querySelector('#' + id);
    let cur = 0;
    // picks: { [variantId]: { qty, title, size, price(cents-ish string), cat } }
    const picks = {};
    // chosen size per product (productId -> variantId) — remembered even before any qty is added
    const sizeSel = {};
    const moneyToCents = str => Math.round(parseFloat(String(str).replace(/[^0-9.]/g, '')) * 100) || 0;
    const pickCount = cat => Object.values(picks).filter(p => p.cat === cat).reduce((n, p) => n + p.qty, 0);
    const totalCents = () => Object.values(picks).reduce((n, p) => n + p.qty * moneyToCents(p.price), 0);
    const totalQty = () => Object.values(picks).reduce((n, p) => n + p.qty, 0);

    function renderSteps() {
      $('ppSteps').innerHTML = steps.map((k, i) => {
        const n = pickCount(k), done = n > 0;
        // label stays inside the bubble: no "(optional)" suffix (the panel copy covers it),
        // and the CSS lets long names ellipsize rather than overflow the pill
        return `<button class="pp-step${i === cur ? ' on' : ''}${done ? ' done' : ''}" data-i="${i}" type="button"${isOptional(k) ? ' title="Optional"' : ''}>
          <span class="pp-step-n">${done ? '✓' : i + 1}</span><span class="pp-step-l">${escHtml(nameOf(k))}</span>
        </button>`;
      }).join('');
    }
    function renderGrid() {
      const k = steps[cur];
      const items = (PREP.cats[k] || []).filter(it => it && it.available !== false);
      $('ppTitle').textContent = (isOptional(k) ? 'Add ' : 'Pick your ') + nameOf(k).toLowerCase();
      $('ppSub').textContent = isOptional(k) ? 'Finishing touches — skip if you like.' : `Step ${cur + 1} of ${steps.length}` + (pickCount(k) ? ` · ${pickCount(k)} picked` : '');
      $('ppGrid').innerHTML = items.map(it => {
        const sizes = (it.sizes || []).filter(sz => sz.a);
        const multi = sizes.length > 1 || (sizes.length === 1 && sizes[0].t);
        // current size for this product = picked one, else the chip they tapped, else the first available
        const pickedSz = sizes.find(sz => picks[sz.id]) || sizes.find(sz => String(sz.id) === String(sizeSel[it.id])) || sizes[0];
        if (!pickedSz) return '';
        const q = picks[pickedSz.id] ? picks[pickedSz.id].qty : 0;
        return `
        <div class="box-item pp-item${q ? ' sel' : ''}" data-pid="${it.id}" data-vid="${pickedSz.id}">
          <span class="box-thumb"${it.img ? ` style="background-image:url('${it.img}')"` : ''}></span>
          <span class="box-item-name">${escHtml(it.title)}</span>
          ${multi ? `<span class="pp-sizes">${sizes.map(sz => `<button type="button" class="bulk-size${sz.id === pickedSz.id ? ' on' : ''}" data-szid="${sz.id}" data-t="${escHtml(sz.t)}" data-p="${escHtml(sz.p)}">${escHtml(sz.t)}</button>`).join('')}</span>` : ''}
          <span class="pp-price">${escHtml(pickedSz.p)}${pickedSz.t ? ` <small>/ ${escHtml(pickedSz.t)}</small>` : ''}</span>
          <span class="box-stepper pp-stepper">
            ${q ? `<button class="box-step" type="button" data-step="dec" aria-label="Remove one">&minus;</button><span class="box-qty">${q}</span>` : ''}
            <button class="box-step" type="button" data-step="inc" aria-label="Add one">+</button>
          </span>
        </div>`;
      }).join('') || '<p class="pp-empty">Nothing available in this category right now.</p>';
    }
    function renderFoot() {
      const last = cur === steps.length - 1;
      const n = totalQty();
      $('ppSummary').innerHTML = n ? `<b>${n} item${n > 1 ? 's' : ''}</b> &middot; <b>${money(totalCents())}</b>` : `<span class="pp-hint">Pick at least one to continue</span>`;
      $('ppBack').style.visibility = cur === 0 ? 'hidden' : 'visible';
      const k = steps[cur];
      const canAdvance = pickCount(k) > 0 || isOptional(k);
      $('ppNext').textContent = last ? (n ? `Add My Prep — ${money(totalCents())}` : 'Add My Prep') : (canAdvance ? 'Next' : (isOptional(k) ? 'Skip' : 'Next'));
      $('ppNext').disabled = last ? n === 0 : !canAdvance;
    }
    function renderAll() { renderSteps(); renderGrid(); renderFoot(); }

    function open() { cur = 0; renderAll(); scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { scrim.classList.remove('open'); document.body.style.overflow = ''; }
    start.addEventListener('click', open);
    $('ppClose').addEventListener('click', close);
    scrim.addEventListener('click', e => { if (e.target === scrim) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && scrim.classList.contains('open')) close(); });
    $('ppSteps').addEventListener('click', e => {
      const b = e.target.closest('.pp-step'); if (!b) return;
      const i = Number(b.dataset.i);
      // allow jumping back freely, forward only through completed/optional steps
      if (i <= cur || steps.slice(0, i).every(k => pickCount(k) > 0 || isOptional(k))) { cur = i; renderAll(); }
    });
    $('ppGrid').addEventListener('click', e => {
      const item = e.target.closest('.pp-item'); if (!item) return;
      const szBtn = e.target.closest('.bulk-size');
      const step = e.target.closest('.box-step');
      const k = steps[cur];
      const prod = (PREP.cats[k] || []).find(it => String(it.id) === item.dataset.pid);
      if (!prod) return;
      if (szBtn) {
        // switching size: move any qty from the old size to the new one
        const oldId = item.dataset.vid, newId = szBtn.dataset.szid;
        sizeSel[prod.id] = newId;
        if (oldId !== newId) {
          const old = picks[oldId];
          if (old) { delete picks[oldId]; picks[newId] = { ...old, size: szBtn.dataset.t, price: szBtn.dataset.p }; }
          item.dataset.vid = newId;
        }
        renderAll(); return;
      }
      if (step) {
        const vid = item.dataset.vid;
        const sz = (prod.sizes || []).find(x => String(x.id) === String(vid)) || {};
        if (step.dataset.step === 'inc') {
          if (!picks[vid]) picks[vid] = { qty: 0, title: prod.title, size: sz.t || '', price: sz.p || prod.price, cat: k };
          picks[vid].qty++;
        } else if (picks[vid]) {
          picks[vid].qty--; if (picks[vid].qty <= 0) delete picks[vid];
        }
        renderAll();
      }
    });
    $('ppBack').addEventListener('click', () => { if (cur > 0) { cur--; renderAll(); } });
    $('ppNext').addEventListener('click', () => {
      const last = cur === steps.length - 1;
      if (!last) { cur++; renderAll(); return; }
      const items = Object.entries(picks).map(([vid, p]) => {
        const it = { id: Number(vid), quantity: p.qty };
        if (p.size) it.properties = { 'Size': p.size };
        return it;
      });
      if (!items.length) return;
      const btn = $('ppNext'); btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
        .then(r => r.json().then(d => ({ ok: r.ok, d })))
        .then(({ ok, d }) => {
          if (!ok) { btn.disabled = false; renderFoot(); alert((d && (d.description || d.message)) || 'Could not add your prep to the cart.'); return; }
          Object.keys(picks).forEach(k => delete picks[k]);
          Object.keys(sizeSel).forEach(k => delete sizeSel[k]);
          close();
          if (typeof refreshCart === 'function') refreshCart();
          if (typeof openCart === 'function') openCart();
        })
        .catch(() => { btn.disabled = false; renderFoot(); alert('Could not add your prep to the cart.'); });
    });
  })();

  // the customer can dismiss the add-on strip (✕) for the current visit to the drawer. It stays
  // hidden through cart updates while the drawer is open, and comes back every time the drawer
  // is reopened — the client wants it re-offered each visit, not remembered.
  let upsellDismissed = false;
  (function () {
    const x = document.getElementById('cuClose');
    if (!x) return;
    x.addEventListener('click', () => {
      upsellDismissed = true;
      const el = document.getElementById('cartUpsell'); if (el) el.hidden = true;
    });
  })();
  function renderUpsell(cart) {
    const el = document.getElementById('cartUpsell'), row = document.getElementById('cuRow');
    if (!el || !row) return;
    if (upsellDismissed) { el.hidden = true; row.innerHTML = ''; return; }
    // one strip at a time: "complete your meal" when the cart has prep items with categories
    // missing, otherwise the dessert treat row (drawer space is hard-won — see cart-foot fixes)
    const recs = cart.items.length ? prepRecs(cart) : null;
    const items = recs || DESSERTS;
    if (!cart.items.length || !items.length) { el.hidden = true; row.innerHTML = ''; return; }
    const labelEl = el.querySelector('.cu-label');
    if (labelEl) {
      if (!labelEl.dataset.orig) labelEl.dataset.orig = labelEl.textContent;
      labelEl.textContent = recs ? ((PREP && PREP.label) || 'Complete your meal') : labelEl.dataset.orig;
    }
    const qtyByVid = {};
    cart.items.forEach(i => { qtyByVid[i.variant_id] = (qtyByVid[i.variant_id] || 0) + i.quantity; });
    row.innerHTML = items.map(d => {
      const q = qtyByVid[d.id] || 0;
      const stepper = q > 0
        ? `<button class="cu-step" type="button" data-step="dec" data-vid="${d.id}" aria-label="Remove one">&minus;</button><span class="cu-qty">${q}</span><button class="cu-step" type="button" data-step="inc" data-vid="${d.id}" aria-label="Add one">+</button>`
        : `<button class="cu-step cu-plus" type="button" data-step="inc" data-vid="${d.id}" aria-label="Add ${escHtml(d.title)}">+</button>`;
      return `
      <div class="cu-card${q > 0 ? ' in-cart' : ''}" data-vid="${d.id}">
        <span class="cu-thumb"${d.img ? ` style="background-image:url('${d.img}')"` : ''}></span>
        <span class="cu-name">${escHtml(d.title)}</span>
        <span class="cu-foot"><span class="cu-price">${escHtml(d.price)}</span><span class="cu-stepper">${stepper}</span></span>
      </div>`;
    }).join('');
    if (recs) { const ob = document.getElementById('cuOffer'); if (ob) ob.hidden = true; }
    else renderOfferProgress(qtyByVid);
    el.hidden = false;
  }

  function renderOfferProgress(qtyByVid) {
    const bar = document.getElementById('cuOffer');
    if (!bar) return;
    if (!OFFER || !OFFER.enabled || !OFFER.buy) { bar.hidden = true; return; }
    const total = DESSERTS.reduce((n, d) => n + (qtyByVid[d.id] || 0), 0);
    const buy = OFFER.buy, get = OFFER.get || 1;
    let msg;
    if (total === 0) msg = escHtml(OFFER.headline || `Add ${buy} desserts, get ${get} free`);
    else if (total < buy) { const n = buy - total; msg = `Add ${n} more dessert${n > 1 ? 's' : ''} &mdash; get ${get} free`; }
    else if (total < buy + get) { const n = buy + get - total; msg = `🎉 You qualify &mdash; add ${n} more, on us`; }
    else msg = escHtml(OFFER.unlocked || '🎉 Free dessert unlocked!');
    bar.innerHTML = msg;
    bar.classList.toggle('on', total >= buy);
    bar.hidden = false;
  }

  (function () {
    const row = document.getElementById('cuRow');
    if (!row) return;
    let busy = false;
    row.addEventListener('click', e => {
      const step = e.target.closest('.cu-step'); if (!step || busy) return;
      const vid = Number(step.dataset.vid); if (!vid) return;
      busy = true;
      const card = step.closest('.cu-card'); if (card) card.classList.add('adding');
      const done = () => { busy = false; };
      const line = cartLineFor(vid);
      if (step.dataset.step === 'inc') {
        (line ? changeLine(line.key, line.quantity + 1) : addVariant(vid)).then(done).catch(done);
      } else if (line) {
        changeLine(line.key, line.quantity - 1).then(done).catch(done);
      } else done();
    });
  })();
  // qty steppers (delegated)
  document.getElementById('cartItems').addEventListener('click', e => {
    const b = e.target.closest('[data-key]'); if (!b) return;
    changeLine(b.dataset.key, parseInt(b.dataset.qty, 10));
  });
  // quick-add on menu/bulk cards (needs a Shopify variant id)
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-add]'); if (!btn) return;
    const vid = btn.dataset.variantId; if (!vid) return;
    const original = btn.innerHTML; btn.classList.add('added');
    // meal-prep cards carry the chosen size (1lb / 8 oz …) so the cart line shows it
    const props = btn.dataset.size ? { 'Size': btn.dataset.size } : (btn.dataset.unit ? { 'Sold by': btn.dataset.unit } : null);
    addVariant(vid, props).then(() => { if (typeof openCart === 'function') openCart(); });
    setTimeout(() => { btn.classList.remove('added'); btn.innerHTML = original; }, 750);
  });
  // native Shopify checkout
  document.getElementById('cartCheckout').addEventListener('click', () => { window.location.href = '/checkout'; });
  document.addEventListener('click', e => { if (e.target.closest('.cartpage-cta.mix-hold')) e.preventDefault(); });
  refreshCart();

  // click a meal card -> its native Shopify product page (the "+" quick-add doesn't navigate)
  (function () {
    const grid = document.getElementById('grid');
    if (!grid) return;
    grid.addEventListener('click', e => {
      if (e.target.closest('[data-add]')) return;
      const card = e.target.closest('.card[data-url]');
      if (card) window.location.href = card.dataset.url;
    });
  })();

  // Macro/badge fallback: fill the protein + corner badge from window.AKTIVATE_MACROS
  // ONLY when the product has no custom.* metafield (so real metafields always win).
  (function () {
    const M = window.AKTIVATE_MACROS;
    if (!M) return;
    document.querySelectorAll('#grid .card[data-handle]').forEach(card => {
      const d = M[card.dataset.handle];
      if (!d) return;
      const imgWrap = card.querySelector('.card-img');
      if (!imgWrap) return;
      if (d.p != null && !card.querySelector('.card-protein')) {
        const s = document.createElement('span');
        s.className = 'card-protein';
        s.textContent = d.p + 'g protein';
        imgWrap.insertBefore(s, imgWrap.firstChild);
      }
      if (d.badge && !card.querySelector('.card-badge')) {
        const s = document.createElement('span');
        s.className = 'card-badge';
        s.textContent = d.badge;
        imgWrap.insertBefore(s, imgWrap.firstChild);
      }
    });
  })();

  /* ===================================================================
     PRODUCT PAGE (native /products/<handle>) — qty stepper, AJAX add,
     macro/badge fallback from window.AKTIVATE_MACROS (metafields win).
     =================================================================== */
  (function () {
    const info = document.getElementById('pvInfo');
    if (!info) return;

    // macros + badge fallback (only when Liquid rendered nothing from metafields)
    const d = (window.AKTIVATE_MACROS || {})[info.dataset.handle];
    const mEl = document.getElementById('pvMacros');
    if (d && mEl && !mEl.children.length) {
      const parts = [];
      if (d.p != null) parts.push([d.p + 'g', 'Protein']);
      if (d.c != null) parts.push([d.c + 'g', 'Carbs']);
      if (d.f != null) parts.push([d.f + 'g', 'Fat']);
      if (d.fib != null) parts.push([d.fib + 'g', 'Fiber']);
      if (d.cal != null) parts.push([d.cal, 'Calories']);
      mEl.innerHTML = parts.map(([val, l]) => `<div class="pv-macro"><span class="pvm-v">${val}</span><span class="pvm-l">${l}</span></div>`).join('');
    }
    const media = document.getElementById('pvMedia');
    if (d && d.badge && media && !media.querySelector('.pv-badge')) {
      const s = document.createElement('span');
      s.className = 'pv-badge'; s.textContent = d.badge;
      media.appendChild(s);
    }

    // size picker (multi-variant products): swap displayed price + the variant the button adds
    const sizesEl = document.getElementById('pvSizes');
    if (sizesEl) sizesEl.addEventListener('click', e => {
      const chip = e.target.closest('.bulk-size'); if (!chip || chip.disabled) return;
      sizesEl.querySelectorAll('.bulk-size').forEach(c => c.classList.toggle('on', c === chip));
      const addBtn = document.getElementById('pvAdd'), priceEl = document.querySelector('.pv-price'), addPrice = document.getElementById('pvAddPrice');
      if (priceEl) priceEl.textContent = chip.dataset.price;
      if (addPrice) addPrice.textContent = chip.dataset.price;
      if (addBtn) { addBtn.dataset.variantId = chip.dataset.vid; addBtn.dataset.size = chip.dataset.size; addBtn.disabled = false; }
    });

    // qty stepper + add to cart (native AJAX cart -> site cart drawer)
    let qty = 1;
    const qEl = document.getElementById('pvQty');
    const minus = document.getElementById('pvMinus'), plus = document.getElementById('pvPlus');
    if (minus) minus.addEventListener('click', () => { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
    if (plus) plus.addEventListener('click', () => { qty = Math.min(20, qty + 1); qEl.textContent = qty; });
    const add = document.getElementById('pvAdd');
    // No subscribe toggle on meal pages — subscription pricing is bundles-only (see aktivate-product.liquid).
    // data-selling-plan is still honoured below so a bundle surface can opt in.
    if (add && add.dataset.variantId) add.addEventListener('click', () => {
      add.disabled = true;
      const item = { id: Number(add.dataset.variantId), quantity: qty };
      if (add.dataset.sellingPlan) item.selling_plan = Number(add.dataset.sellingPlan);
      if (add.dataset.size) item.properties = { 'Size': add.dataset.size };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }) })
        .then(r => r.json().then(dd => ({ ok: r.ok, dd })))
        .then(({ ok, dd }) => {
          add.disabled = false;
          if (!ok) { alert((dd && (dd.description || dd.message)) || 'Could not add to cart.'); return; }
          if (typeof refreshCart === 'function') refreshCart();
          if (typeof openCart === 'function') openCart();
        })
        .catch(() => { add.disabled = false; });
    });
  })();

  /* ===================================================================
     GIFT CARD (snippets/aktivate-gift-card.liquid) — native Shopify gift
     card product. Amount = the chosen variant (Shopify prices it). "Send as
     a gift" adds Shopify's recipient properties, so Shopify emails the
     recipient after payment. Entries are kept on any error.
     =================================================================== */
  (function () {
    const form = document.getElementById('gcForm');
    if (!form) return;
    const $ = id => document.getElementById(id);
    const email = $('gcEmail'), name = $('gcName'), msg = $('gcMsg'), btn = $('gcAdd'), formErr = $('gcFormErr');
    const recip = $('gcRecipient'), selfHint = $('gcSelfHint'), emailErr = $('gcEmailErr');
    const addLabel = form.dataset.addLabel || 'Add Gift Card';
    const isGift = () => (form.querySelector('input[name="gc_who"]:checked') || {}).value === 'gift';
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    // "Custom": the typed amount must match one of the product's denominations (#gcVariants) —
    // the range and step shown to the customer are derived from them, never hard-coded
    const cust = $('gcCustom'), custWrap = $('gcCustomWrap'), custErr = $('gcCustomErr');
    const byCents = new Map((cust ? JSON.parse($('gcVariants').textContent) : []).filter(v => v.a).map(v => [v.c, v.id]));
    const cents = [...byCents.keys()].sort((x, y) => x - y);
    const gcd = (x, y) => y ? gcd(y, x % y) : x;
    const stepC = cents.reduce((g, c) => gcd(g, c - cents[0]), 0) || 100;
    const short = c => c % 100 ? money(c) : '$' + (c / 100).toLocaleString('en-US');
    const rangeMsg = cents.length ? `Enter an amount from ${short(cents[0])} to ${short(cents[cents.length - 1])}${stepC > 100 ? `, in ${short(stepC)} steps` : stepC === 100 ? ', in whole dollars' : ''}.` : '';
    if (cust) $('gcCustomHint').textContent = rangeMsg.replace(/^Enter an amount/, 'Any amount');
    const isCustom = () => (form.querySelector('input[name="gc_variant"]:checked') || {}).value === 'custom';
    function customCents() {
      const raw = cust.value.replace(/[$,\s]/g, '');
      return /^\d+(\.\d{1,2})?$/.test(raw) ? Math.round(parseFloat(raw) * 100) : null;
    }
    // the chosen amount → { id, price, short }, or null when the custom amount isn't a denomination
    function amount() {
      const r = form.querySelector('input[name="gc_variant"]:checked');
      if (!r) return null;
      if (r.value !== 'custom') return { id: Number(r.value), price: r.dataset.price, short: r.dataset.short };
      const c = customCents(), id = c != null && byCents.get(c);
      return id ? { id, price: money(c), short: short(c) } : null;
    }
    const btnHtml = a => `${escHtml(addLabel)}${a ? ` &mdash; <span id="gcAddPrice">${escHtml(a.price)}</span>` : ''}`;

    function setEmailError(text) {
      emailErr.textContent = text || '';
      if (text) email.setAttribute('aria-invalid', 'true'); else email.removeAttribute('aria-invalid');
    }
    function setCustomError(text) {
      if (!cust) return;
      custErr.textContent = text || '';
      if (text) cust.setAttribute('aria-invalid', 'true'); else cust.removeAttribute('aria-invalid');
    }
    function render() {
      const a = amount(), gift = isGift();
      if (custWrap) custWrap.hidden = !isCustom();
      $('gcCardAmt').textContent = a ? a.short : '$—';
      $('gcSumAmt').textContent = a ? a.price : '—';
      if (!btn.hasAttribute('aria-busy')) btn.innerHTML = btnHtml(a);
      recip.hidden = !gift; selfHint.hidden = gift;
      [email, name, msg].forEach(el => { el.disabled = !gift; });
      const to = gift && email.value.trim();
      $('gcSumTo').textContent = gift ? (to ? `· emailed to ${to}` : '· emailed to your recipient') : '· emailed to you';
      $('gcMsgCount').textContent = `${msg.value.length} / 200`;
    }
    form.addEventListener('change', e => {
      if (e.target.name === 'gc_who' && isGift()) email.focus();
      if (e.target.name === 'gc_variant') setCustomError('');
      render();
      if (e.target.name === 'gc_variant' && isCustom()) cust.focus();
    });
    form.addEventListener('input', e => {
      if (e.target === email && emailErr.textContent && EMAIL_RE.test(email.value.trim())) setEmailError('');
      if (e.target === cust && custErr.textContent && amount()) setCustomError('');
      render();
    });
    if (cust) cust.addEventListener('blur', () => { if (isCustom() && cust.value.trim() && !amount()) setCustomError(rangeMsg); });

    form.addEventListener('submit', e => {
      e.preventDefault();
      formErr.textContent = '';
      const a = amount();
      if (!a && isCustom()) { setCustomError(rangeMsg); cust.focus(); return; }
      if (!a) { formErr.textContent = 'Choose a gift card amount.'; return; }
      const item = { id: a.id, quantity: 1 };
      if (isGift()) {
        const to = email.value.trim();
        if (!to) { setEmailError('Enter the recipient’s email address.'); email.focus(); return; }
        if (!EMAIL_RE.test(to)) { setEmailError('Enter a valid email address, like name@example.com.'); email.focus(); return; }
        setEmailError('');
        item.properties = { '__shopify_send_gift_card_to_recipient': 'on', 'Recipient email': to };
        if (name.value.trim()) item.properties['Recipient name'] = name.value.trim();
        if (msg.value.trim()) item.properties['Message'] = msg.value.trim().slice(0, 200);
      }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
      const done = () => { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = btnHtml(amount()); };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] }) })
        .then(r => r.json().then(dd => ({ ok: r.ok, dd })))
        .then(({ ok, dd }) => {
          done();
          if (!ok) {
            const why = (dd && (dd.description || dd.message)) || '';
            if (/email/i.test(why) && isGift()) { setEmailError(why); email.focus(); }
            else formErr.textContent = why || 'We couldn’t add the gift card. Please try again.';
            return;
          }
          if (typeof refreshCart === 'function') refreshCart();
          if (typeof openCart === 'function') openCart();
        })
        .catch(() => { done(); formErr.textContent = 'Connection problem — your details are saved. Please try again.'; });
    });
    render();
  })();

  /* ===================================================================
     SMS OFFER (sections/aktivate-sms-offer.liquid) — popup on a visitor's
     first visit; only the X (or Escape) closes it, never a backdrop click.
     Once closed, the corner tab reopens it any time. After a successful
     signup neither shows again. Per-browser memory only (localStorage).
     =================================================================== */
  (function () {
    const root = document.getElementById('smsOffer');
    if (!root) return;
    const scrim = document.getElementById('smsScrim'), modal = document.getElementById('smsModal');
    const closeBtn = document.getElementById('smsClose'), tab = document.getElementById('smsTab');
    const formWrap = document.getElementById('smsForm');
    const SEEN = 'aktSmsOfferSeen', DONE = 'aktSmsOfferDone';
    const store = {
      get: k => { try { return localStorage.getItem(k); } catch (_) { return null; } },
      set: k => { try { localStorage.setItem(k, '1'); } catch (_) {} }
    };
    const designMode = root.hasAttribute('data-design-mode');
    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      scrim.hidden = false; tab.hidden = true;
      document.body.style.overflow = 'hidden';
      modal.focus();
    }
    function close() {
      scrim.hidden = true;
      document.body.style.overflow = '';
      if (!designMode) store.set(SEEN);
      if (store.get(DONE)) { root.remove(); return; }
      tab.hidden = false;
      (lastFocus && lastFocus !== document.body ? lastFocus : tab).focus();
    }
    closeBtn.addEventListener('click', close);
    tab.addEventListener('click', open);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !scrim.hidden) close(); });
    // keep keyboard focus inside the dialog while it's open
    modal.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const f = [...modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // signed up → remember it. The Shopify Forms block renders in an (open) shadow root and swaps in
    // its success message with the code, so read the text from there while the popup is open.
    const formText = () => [formWrap, ...[...formWrap.querySelectorAll('*')].map(el => el.shadowRoot).filter(Boolean)]
      .map(r => r.textContent || '').join(' ');
    const isSuccess = () => /your 50% off code|here'?s your discount/i.test(formText());
    setInterval(() => { if (!scrim.hidden && !store.get(DONE) && isSuccess()) store.set(DONE); }, 1000);

    // theme editor: selecting this section opens the popup so it can be edited
    document.addEventListener('shopify:section:select', e => { if (e.target.contains(root)) open(); });
    document.addEventListener('shopify:section:deselect', e => { if (e.target.contains(root) && !scrim.hidden) close(); });

    if (store.get(DONE) && !designMode) { root.remove(); return; }
    if (designMode || store.get(SEEN)) { tab.hidden = false; return; } // editor: never auto-open over the page
    setTimeout(open, (parseInt(root.dataset.delay, 10) || 0) * 1000);
  })();

  /* ===== SCROLL REVEAL ===== */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' }); // threshold 0 so tall blocks (e.g. the single-column mobile menu grid) reveal as their top edge enters — a % threshold is unreachable when the element is taller than the viewport
  document.querySelectorAll('.reveal').forEach((el, i) => {
    const sibs = el.parentElement.querySelectorAll(':scope > .reveal');
    if (sibs.length > 1) { const idx = [...sibs].indexOf(el); el.style.transitionDelay = `${idx * 90}ms`; }
    io.observe(el);
  });
